module.exports = __webpack_public_path__ + "static/media/stock-enquiry.631c5665.svg";